import { render, staticRenderFns } from "./mapLocalizar.vue?vue&type=template&id=2da0acc0&scoped=true&"
import script from "./mapLocalizar.vue?vue&type=script&lang=js&"
export * from "./mapLocalizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da0acc0",
  null
  
)

export default component.exports